import { previewModeEnabled } from "./preview-mode.utils";

export const useIsPreviewModeEnabled = () => {
  return previewModeEnabled();
};
